module.exports = __webpack_public_path__ + "img/cata_v2_small.97170f72.png";